enum MessageChannel {
    MAIL = 'mail',
    PUSH = 'push',
}

export default MessageChannel